import { Link } from 'react-router-dom';
import { Download } from 'lucide-react';
import '../AllCss/VehicleSourcingFeeAgreementPdf.css';

const PDF_PATH = '/legal/vehicle-sourcing-fee-agreement.pdf';

export default function VehicleSourcingFeeAgreement() {
  return (
    <div className="vsf-pdf-shell">
      <header className="vsf-pdf-toolbar">
        <Link to="/profile?tab=interestedIn" className="vsf-pdf-back">
          ← Back
        </Link>
        <span className="vsf-pdf-toolbar-title">Vehicle Sourcing Fee Agreement</span>
        <a href={PDF_PATH} download className="vsf-pdf-download" target="_blank" rel="noopener noreferrer">
          <Download size={16} aria-hidden />
          Download PDF
        </a>
      </header>
      <object
        data={PDF_PATH}
        type="application/pdf"
        className="vsf-pdf-object"
        title="Vehicle Sourcing Fee Binding Order Agreement"
      >
        <div className="vsf-pdf-fallback">
          <p>Your browser could not display the PDF inline.</p>
          <a href={PDF_PATH} target="_blank" rel="noopener noreferrer">
            Open the PDF
          </a>
          {' · '}
          <a href={PDF_PATH} download>
            Download
          </a>
        </div>
      </object>
    </div>
  );
}
